import React from 'react';

export default function LegalDocument({ heading, lastUpdated, introHtml, sections }) {
    return (
        <section className="sp-90">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                        <h1 className="h-1 h-bold text-left">{heading}</h1>
                        <p className="paragraph p-adjustment text-left">{lastUpdated}</p>
                        {introHtml ? (
                            <div dangerouslySetInnerHTML={{ __html: introHtml }} />
                        ) : null}
                        {sections.map((section) => (
                            <div className="question mt-40" key={section.id}>
                                <h4 className="h-4 h-bold">
                                    <span style={{ opacity: '0.4', marginRight: '10px' }}>
                                        {section.number}
                                    </span>
                                    {section.title}
                                </h4>
                                <div dangerouslySetInnerHTML={{ __html: section.bodyHtml }} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}